export class MedicineInteractionContentModel {
  public medicineId: number;
  public langId: number;
  public description: string;
}